import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useApplyBrandingSettingsAgentOfficeMutation = (companyId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		() =>
			brandingService.applyBrandingSettingsAgentOffice({
				companyId,
			}),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useApplyBrandingSettingsAgentOfficeMutation;
